var poll_default = {
  "fontElementMap": "_2Qx9G",
  "container": "Fhnxl",
  "fullscreen": "gy2aA",
  "background_overlay": "TGDO2",
  "with_image": "EfQ5q",
  "options": "_4B4L2",
  "webview": "pPjyp",
  "grid": "g8Odv",
  "option": "zPiX8",
  "cta_button": "U0Sdr",
  "add_option": "CPK1o",
  "see_more": "CbPFf",
  "list": "_72-KP",
  "column": "_5DXFJ",
  "additional_note": "HciQ8",
  "spinner": "uRb2g",
  "spin": "yCGRW",
  "shown": "NbjUC",
  "error": "KyAnn"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
